import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";

import { Container, Row, Col, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import { TUTOR_NOTIFICATION_API } from "../../../api/api";

// import notificationImgsss from "../../../assets/notification-empty-icon.png";
import Announcementsimg from "../../../assets/announcements-empty.png";
import { IoCheckmarkCircleOutline } from "react-icons/io5";

import Assignment from "../../../assets/notfication-ass-icon.png";
import Query from "../../../assets/notification-student-que-icon.png";
import Payment from "../../../assets/notification-payment-icon.png";
import Feedback from "../../../assets/notification-feedback-icon.png";
import System from "../../../assets/notification-system-icon.png";

// import Noofstudents from "../../../assets/all-assignments-icon.png";
// import TotalQueries from "../../../assets/all-assignments-icon.png";
// import Unresolved from "../../../assets/all-assignments-icon.png";
// import Resolved from "../../../assets/all-assignments-icon.png";
// import ResponseRate from "../../../assets/all-assignments-icon.png";

// latestIcons
import totalNotification from "../../../assets/icons/tutor/tutor-notification-bell.svg";
import assignments from "../../../assets/icons/student/assignment.svg";
import queries from "../../../assets/icons/tutor/queries.svg";
import feedback from "../../../assets/icons/tutor/feedback.svg";

import { handleApiError } from "../../../utils/apiErrorHandler";

import "./TutorNotifications.css";

// ICON MAP
const TYPE_ICONS = {
  "Final Assignment": Assignment,
  Chats: Query,
  Feedback: Feedback,
  Payment,
  System,
};

// BACKEND → UI TYPE MAP
const TYPE_MAP = {
  chat: "Chats",
  "Final Assignment Submited": "Final Assignment",
  "Feedback Submitted": "Feedback",
};

const TABS = [
  { id: "all", label: "All" },
  { id: "unread", label: "Unread" },
  { id: "Final Assignment", label: "Final Assignments" },
  { id: "Chats", label: "Chats" },
  // { id: "Payment", label: "Payments" },
  { id: "Feedback", label: "Feedback" },
  // { id: "System", label: "System" },
];

const TYPE_ROUTE_MAP = {
  chat: "/header/tutor/student-doubts",
  "Final Assignment Submited": "/header/tutor/assignments",
  "Feedback Submitted": "/header/tutor/feedback",
};

const TutorNotifications = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("all");

  const [tutorNotifiStats, setTutorNotifiStats] = useState({});
  const [notifications, setNotifications] = useState([]);
  const [showScrollbar, setShowScrollbar] = useState(false);

  //loading
  const [loadingAllNotifications, setloadingAllNotifications] = useState(true);

  // main toast error
  const showErrorToast = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 1500,
      theme: "colored",
    });
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");

    if (!userId || !token) {
      setloadingAllNotifications(false);
      navigate("/signin");

      return;
    }

    const fetchNotification = async () => {
      try {
        const response = await axios.post(
          TUTOR_NOTIFICATION_API.GET_TUTOR_NOTIFICATION_DASHBOARD,
          { tutor_id: userId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const data = response.data;

        if (data.statusCode === 200) {
          setTutorNotifiStats(data.data.dashboard || {});

          const formattedNotifications = (data.data.notifications || []).map(
            (n) => ({
              notificationId: n.notification_id,
              // title: n.type || "Notification",
              desc: n.message,
              time: n.time_ago,
              read: n.is_read,
              type: TYPE_MAP[n.type] || "",
              rawType: n.type,
            }),
          );

          setNotifications(formattedNotifications);
        } else {
          // This will handle any 2xx response that is not 201
          showErrorToast(data.message);
        }
      } catch (error) {
        console.error("Error fetch notification:", error);
        // Server responded with non-2xx status (like 400, 500)

        // CHECK (expiry / invalid token)
        handleApiError(error, navigate, showErrorToast, "/signin");
      } finally {
        setloadingAllNotifications(false);
      }
    };

    fetchNotification();
  }, [navigate]);

  // filtered notifications
  const filteredNotifications = useMemo(() => {
    if (activeTab === "all") return notifications;

    if (activeTab === "unread") return notifications.filter((n) => !n.read);

    // Filter by type (Assignments, Queries, Feedback, etc.)
    return notifications.filter((n) => n.type === activeTab);
  }, [notifications, activeTab]);

  const handleScroll = () => {
    setShowScrollbar(true);

    clearTimeout(window.scrollTimer);

    window.scrollTimer = setTimeout(() => {
      setShowScrollbar(false);
    }, 700); // hide after 800ms stop scrolling
  };

  const handleNotificationClick = (item) => {
    const route = TYPE_ROUTE_MAP[item.rawType];

    if (route) {
      navigate(route);
    } else {
      console.warn("No route mapped for:", item.rawType);
    }
  };

  if (loadingAllNotifications) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <Container className="tutor-notification-sections-container">
      <h4 className="tutor-notification-top-title">Notifications</h4>
      <p className="tutor-notification-top-paragraph">
        Stay updated with course activities and student updates. 
      </p>

      <Row className="tutor-notification-topcards-section">
        <Col lg={3} md={4} sm={6} xs={12}>
          <div className="tutor-notification-topcard-box">
            <h6>Total Notification</h6>
            <img
              src={totalNotification}
              alt="Notification"
              className="tutor-notification-topcard-icon"
            />
            <h3>{Number(tutorNotifiStats.total_notifications) || "-"}</h3>
          </div>
        </Col>

        <Col lg={3} md={4} sm={6} xs={12}>
          <div className="tutor-notification-topcard-box">
            <h6>Final Assignments</h6>
            <img
              src={assignments}
              alt="Assignments"
              className="tutor-notification-topcard-icon"
            />
            <h3>{Number(tutorNotifiStats.assignments) || "-"}</h3>
          </div>
        </Col>

        <Col lg={3} md={4} sm={6} xs={12}>
          <div className="tutor-notification-topcard-box">
            <h6>Chat</h6>
            <img
              src={queries}
              alt="Queries"
              className="tutor-notification-topcard-icon"
            />
            <h3>{Number(tutorNotifiStats.chat) || "-"}</h3>
          </div>
        </Col>

        {/* <Col lg={2} md={4} sm={6} xs={12}>
          <div className="tutor-notification-topcard-box">
            <h6>Payments</h6>
            <img
              src={Resolved}
              alt="Graded Icon"
              className="tutor-notification-topcard-icon"
            />
            <h3>4.77</h3>
          </div>
        </Col> */}

        <Col lg={3} md={4} sm={6} xs={12}>
          <div className="tutor-notification-topcard-box">
            <h6>Feedback</h6>
            <img
              src={feedback}
              alt="Feedback"
              className="tutor-notification-topcard-icon"
            />
            <h3>{Number(tutorNotifiStats.feedbacks) || "-"}</h3>
          </div>
        </Col>
      </Row>

      {/* Tabs */}
      <Row className="mb-1 align-items-center">
        <Col lg={7} md={7} sm={12}>
          <div className="tutor-notification-sections-tabs">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                className={`tutor-notification-sections-tab-btn ${
                  activeTab === tab.id ? "active" : ""
                }`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </Col>

        {/* <Col lg={5} md={5} sm={12} className="text-end mt-sm-2 mt-md-0">
          <Button
            className="tutor-notification-sections-markread"
            onClick={markAllAsRead}
          >
            Mark As Read
          </Button>
        </Col> */}
      </Row>

      {/* Notification List */}
      <Row>
        <Col md={12}>
          {filteredNotifications.length > 0 ? (
            <div
              className={`tutor-notification-list-scroll ${
                showScrollbar ? "show-scrollbar" : ""
              }`}
              onScroll={handleScroll}
            >
              {filteredNotifications.map((item) => (
                <div
                  key={item.notificationId}
                  onClick={() => handleNotificationClick(item)}
                  className={`tutor-notification-sections-card ${
                    !item.read ? "tutor-notification-sections-card-unread" : ""
                  }`}
                >
                  <div className="d-flex justify-content-between align-items-start">
                    {/* LEFT SIDE */}
                    <div className="d-flex align-items-start">
                      <img
                        src={TYPE_ICONS[item.type] ?? Query}
                        alt={item.type}
                        className="tutor-notification-icon"
                      />

                      <div className="ms-3">
                        {/* <h6 className="tutor-notification-sections-title">
                        {item.title}
                      </h6> */}
                        <p className="tutor-notification-sections-desc">
                          {item.desc}
                        </p>
                        <span className="tutor-notification-sections-time">
                          {item.time}
                        </span>
                      </div>
                    </div>

                    {/* RIGHT SIDE */}
                    <div className="tutor-notification-sections-right">
                      <span
                        className={`tutor-notification-sections-badge ${(item.type || "").toLowerCase().replace(/\s+/g, "-")}`}
                      >
                        {item.type}
                      </span>

                      {item.read && (
                        <div className="tutor-notification-sections-readtext">
                          <IoCheckmarkCircleOutline /> Read
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="tutor-notification-empty">
              <img
                src={Announcementsimg}
                alt="No Notifications"
                className="tutor-notification-empty-img mb-3"
              />
              <h5>No notifications available.</h5>
              <p>New updates will appear here as they arrive.</p>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default TutorNotifications;
